<template>
  <nav class="flex flex-col gap-10 w-[16rem] relative" :class="{'opacity-50 pointer-events-none': !userProfileCompleted}">
    <t-image-text
      @click.native="goToRoot()"
      :horizontal="true"
      class="items-center gap-2 text-black cursor-pointer"
      v-if="appLogo && appName && showLogo"
    >
      <img :src="appLogo" :alt="appName" class="rounded-md max-w-14 max-h-14" />
      <t-heading tag="h3" class="font-semibold">{{ appName }}</t-heading>
    </t-image-text>
    <div
      class="flex flex-col gap-1 pb-20 overflow-x-hidden overflow-y-scroll scrollbar-hidden"
      :class="{'mt-14': !showLogo || !appLogo || !appName}"
    >
      <slot>
        <t-list-item
          v-for="item in userMenu"
          :ref="`sidebar.${item.app_module_id}`"
          :key="`sidebar.${item.app_module_id}`"
          :to="`/${item.type}/${item.app_module_id}`"
          :iconSrc="item.icon"
          :bubble="item.bubble.length"
          :bubbleType="$helpers.getBubbleTypeFromMenuType(item.type)"
          :active="$route.fullPath.split('/')[2] == item.app_module_id"
          :text="item.name"
        />
      </slot>
    </div>

    <!-- Internal app notifications (only desktop) -->
    <app-notifications />
  </nav>
</template>

<script>
  import {mapGetters} from 'vuex'
  import AppNotifications from '@/components/AppNotifications.vue'
  export default {
    name: 't-sidebar-left',
    props: {
      showLogo: {
        type: Boolean,
        default: true
      }
    },
    components: {
      AppNotifications
    },
    computed: {
      ...mapGetters('user', ['userMenu', 'menuLoaded', 'userFirstModule', 'userProfileCompleted']),
      ...mapGetters(['appLogo', 'appName'])
    },
    methods: {
      goToRoot() {
        this.$router.push({name: `${this.userFirstModule.type}.index`, params: {app_module_id: this.userFirstModule.app_module_id}})
      }
    }
  }
</script>
